import { Component, OnInit } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'app-custom-slider-type',
  templateUrl: './custom-slider-type.component.html',
  styleUrls: ['./custom-slider-type.component.scss']
})
export class CustomSliderTypeComponent extends FieldType<FieldTypeConfig>  implements OnInit {


  ngOnInit(): void {
  }

}
